import { Session } from 'sip.js';

export enum TerminationReason {
  USER_HANGUP = 'USER_HANGUP',
  CANCEL = 'CANCEL',
  REMOTE_BYE = 'REMOTE_BYE',
  NO_ANSWER = 'NO_ANSWER',
  NETWORK_TIMEOUT = 'NETWORK_TIMEOUT',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  SIP_ERROR = 'SIP_ERROR',
  WEBRTC_FAILURE = 'WEBRTC_FAILURE',
  UNKNOWN = 'UNKNOWN',
}

export type SessionWithInternals = Session & SessionInternals;
export type Platform = 'web';

export type SessionTerminationDetails = {
  statusCode?: number;
  reasonPhrase?: string;
  cause?: string;
  [key: string]: unknown;
};

export type SessionInternals = {
  _dialog?: {
    remoteTarget?: unknown;
  };
  _terminationDetails?: SessionTerminationDetails;
};

export type ExtractedTerminationData = {
  reason?: TerminationReason;
  statusCode?: number;
  reasonPhrase?: string;
  sipjsCause?: string;
  additionalDetails?: Record<string, unknown>;
};

export type TerminationDetails = {
  sipStatusCode?: number;
  sipReasonPhrase?: string;
  sipjsCause?: string;
  [key: string]: any;
};

export type CallTerminationEvent = {
  eventName: 'CallTerminationEvent';
  timestamp: string;
  platform: Platform;
  personId: string;
  callId: string;
  caller: string;
  callee: string;
  callDurationSeconds: number;
  terminationReason: TerminationReason;
  terminationDetails?: TerminationDetails;
};

export type CreateEventParams = {
  callId: string;
  personId: string;
  caller: string;
  callee: string;
  terminationReason: TerminationReason;
  callDurationSeconds?: number;
  platform?: Platform;
  sipStatusCode?: number;
  sipReasonPhrase?: string;
  sipjsCause?: string;
  callStartTime?: string;
  additionalTerminationDetails?: Record<string, any>;
};
